import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import NavBar from './components/NavBar';
import CssBaseline from '@mui/material/CssBaseline';
import styles from "./App.module.scss"
import MainPage from "./components/MainPage";

const App: React.FC = () => {
    return (
        <>
            <CssBaseline/>
            <NavBar/>
            <Router>
                <div className={styles.mainApp}>
                    <MainPage/>
                </div>
            </Router>
        </>
    );
};

export default App;